import styled from 'styled-components';

const Content = styled.div`
  flex: 1;
  white-space: pre-wrap;
  font-weight: ${({bold}) => (bold ? '700' : '400')};
`;

export default Content;
